import { useRecoilValue, useSetRecoilState } from 'recoil';

import { detailsDataState } from 'components/common/Managers/ViewStateManager.state';

export const useDetailsData = () => useRecoilValue(detailsDataState);

export const useSetDetailsData = () => useSetRecoilState(detailsDataState);
